import { REQUEST_NKUSES} from '../../../const';

export default function NKUSESReducer(state = [], action) {
  switch (action.type) {
      case REQUEST_NKUSES:
        return action.num_of_kuses;
    default:
      return state;
  }
}